import { useState, useEffect, useContext } from "react";
import { CourseTableComp, DashboardTable } from "../components/courseTableComp";
import { GraphComp } from "../components/graphComp";
import { KpiComp } from "../components/kpiComp";
import { HorizontalLayout, VerticalLayout, VerticalPageLayout } from "../components/layout";
import { RecentActivities } from "../components/recentActivities";
import { TopBar } from "../components/topbar";
import { StatsRow } from "../molecule/statsrow";
import { getAPI, postAPI } from "../api/api";
import { Table } from "../components/table";
import { VideoFallback } from "../molecule/VideoFallback";
import dashboardIntroVideo from "../assets/video/dashboard-intro.mp4";
import dashboardIntroVideoTablet from "../assets/video/dashboard-intro-tablet.mp4";
import dashboardIntroVideoPhone from "../assets/video/dashboard-intro-phone.mp4";
import { PageContext } from "../App";
import { IconAtom2 } from "../atoms/iconAtom";
import { DashboardBoardGraph } from "../components/dashboardGraph";

export function Dashboard({ props, pageSwap }) {
  const [isLoading, setIsLoading] = useState(true);
  const [simplePeriod, setSimplePeriod] = useState({});
  const [graphPeriod, setGraphPeriod] = useState({});
  const [stats, setStats] = useState([]);
  const [availableMetrics, setAvailableMetrics] = useState({});
  const [statKeys, setStatKeys] = useState([]);
  const [graphStats, setGraphStats] = useState({});
  const [graphStatKeys, setGraphStatKeys] = useState([]);
  const [availableGraphs, setAvailableGraphs] = useState({});
  const [tableData, setTableData] = useState({});
  const navigationContext = useContext(PageContext);
  function getGraphDataset(stats, key) {
  if (!stats || !key || !Array.isArray(stats[key]?.graph_stats)) return [];
  return stats[key].graph_stats.map(item => Number(item.total_value) || 0);
}
  const GoToReport = (id_course) => {
    console.log("selected id: ", id_course)
    navigationContext.handleNavigation({
      navigation: 11,
      courseID: id_course,
      enrollment: 0,
    })
  }
 useEffect(() => {
  // initializeDashboard();
  loadStatsRow()
}, []);


 const loadStatsRow = async () => {
    const stats = await getAPI('api/reports/dashboard')
    console.log(stats)
    setStats(stats.data)
 }  




 const graphDataset = getGraphDataset(graphStats, graphStatKeys[0]);
  const loadStats = async () => {
    const stat = await getAPI(`api/reports/dashboard`);
    setStats(stat.data);
  };
 const firstKey = graphStatKeys[0];
  const graphTitle = firstKey && graphStats[firstKey]?.pretty_name;

if (!isLoading && statKeys.length === 0 && graphStatKeys.length === 0) {
  return <VideoFallback subTitle={"Er zijn op dit moment nog geen statistieken beschikbaar. Bekijk de introductievideo om je op weg te helpen."} title={"Dashboard"} pageSwap={pageSwap} desktopSrc={dashboardIntroVideo} tabletSrc={dashboardIntroVideoTablet} phoneSrc={dashboardIntroVideoPhone} />
}
  return (
    <VerticalPageLayout className={`page-in-animation ${pageSwap && "page-out-animation"}`}>

      <StatsRow stats={stats} loadStats={loadStats} />
      <HorizontalLayout className="dashboard-graph" style={{ alignItems: "unset" }}>
      <div className="vertical side-content-left complete-width dashboard-graph-content" style={{"height": "max-content"}}>
          <div
            className="vertical graph standard-rounded standard-padding card-background-color standard-border "
            style={{ width: "unset" }}
          >
          <DashboardBoardGraph/>
            
            
          </div>
          <DashboardTable GoToReport={GoToReport} data={tableData}/>
          </div>
        <div className="vertical right-content side-content-right dashboard-graph-content">
          <div
            className="vertical graph standard-rounded standard-padding card-background-color standard-border "
            style={{ width: "unset" }}
          >
            <GraphComp graph={"doughnut"} title={"Jouw licentie"} value={500} />
          </div>
          <RecentActivities
           
          />
        </div>
      </HorizontalLayout>
    </VerticalPageLayout>
  );
}
